import React, { useState, useEffect, useContext } from "react";

import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import { useHistory } from "react-router-dom";

import api from "../../services/api";
import { notify } from "../../utils/notify";
import MaskService from "../../utils/mask/maskService";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validatesNotNull from "../../utils/validatesNotNull";
import { UserContext } from "../../context/UserContext";
import { changedValues } from "../../utils/changedValues";
import SelectCustom from "../../components/basic/SelectCustom";
import { editUser } from "../../repositories/userRepository";
import TextFieldCustom from "../../components/basic/TextFieldCustom";

const UpdateUser = ({ location }) => {
  const { user, setUser } = useContext(UserContext);
  const { goBack } = useHistory();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(location.state.row.Nome);
  const [telephone, setTelephone] = useState(location.state.row.Telefone);
  const [promoter, setPromoter] = useState(null);
  const [typeUser, setTypeUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [active, setActive] = useState(location.state.row.FlagAtivo === "S");
  const [optionsPromoters, setOptionsPromoters] = useState([]);
  const [optionsTypeUsers, setOptionsTypeUsers] = useState([
    { Id: 0, Nome: "" },
  ]);
  const [optionsProfiles, setOptionsProfiles] = useState([
    { Id: 0, Descricao: "" },
  ]);
  const [initialState, setInitialState] = useState({
    Nome: location.state.row.Nome,
    Telefone: location.state.row.Telefone,
    IdTipoUsuario: location.state.row.IdTipoUsuario,
    IdPerfilAcesso: location.state.row.IdPerfilAcesso,
    FlagAtivo: location.state.row.FlagAtivo === "S",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const { data: result } = await api.get(`usuario/dadosParaCriarUsuario`);
        const data = result.data;

        data.typeUsers.unshift({ Id: 0, Nome: "" });
        data.profiles.unshift({ Id: 0, Descricao: "" });

        setOptionsPromoters(data.promoters);
        setOptionsTypeUsers(data.typeUsers);
        setOptionsProfiles(data.profiles);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getData();
  }, [user.IdTipoUsuario]);

  useEffect(() => {
    const profileSelected = optionsProfiles.find(
      (op) => op.Id === location.state.row.IdPerfilAcesso
    );
    if (profileSelected) {
      setPromoter({
        CNPJ: location.state.row.PromotorCNPJ,
        Fantasia: location.state.row.Promotor,
      });
      setTypeUser(
        optionsTypeUsers.find(
          (typeUserOpt) => typeUserOpt.Id === location.state.row.IdTipoUsuario
        )
      );
      setProfile(profileSelected);
    }
  }, [location.state.row, optionsProfiles, optionsPromoters, optionsTypeUsers]);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      let validationFail = false;

      const resultValidation = validatesNotNull([
        { value: name, key: "name" },

        { value: telephone, key: "telephone" },
        { value: promoter, key: "promoter" },
        { value: typeUser, key: "typeUser" },
        { value: profile, key: "profile" },
      ]);

      if (telephone && !MaskService.isValid("cel-phone", telephone)) {
        validationFail = true;
        resultValidation.errorsValidation.telephone = true;
        notify("O telefone informado é inválido.", true, "error");
      }

      if (resultValidation.error || validationFail) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      } else {
        setErrors({});
      }

      const body = changedValues({
        initial: initialState,
        current: {
          Nome: name,
          Telefone: telephone,
          IdTipoUsuario: typeUser.Id,
          IdPerfilAcesso: profile.Id,
          FlagAtivo: active,
        },
      });

      if (Object.keys(body).length < 1) return setLoading(false);

      if (typeof body.FlagAtivo !== "undefined") {
        body.FlagAtivo = body.FlagAtivo ? "S" : "N";
      }

      const result = await editUser({ id: location.state.row.Id, body });

      if (result) {
        setInitialState(Object.assign(initialState, body));

        notify("Usuário atualizado com sucesso.", true, "info");

        if (location.state.row.Id === parseInt(user.Id)) {
          setUser(body);
        }

        setLoading(false);

        goBack();
      }
    } catch (error) {
      console.error("ERROR: UpdateUser", error);
      return setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={6}
          md={7}
          sm={7}
          xs={10}
          id="formContent"
        >
          <ArrowBackIcon className="iconGoBack" onClick={goBack} />

          <label className="title">{location.state.row.Nome}</label>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Nome*"
              autoFocus
              type="text"
              value={name}
              error={errors.name}
              setValue={setName}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="E-mail*"
              disabled
              type="text"
              value={location.state.row.Email}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              label="Telefone*"
              value={MaskService.toMask("cel-phone", telephone)}
              error={errors.telephone}
              mask="cel-phone"
              setValue={setTelephone}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <SelectCustom
              label="Promotor*"
              disabled
              keyObject="Fantasia"
              value={promoter}
              setValue={setPromoter}
              error={errors.promoter}
              key="select-promoter"
              optionsList={optionsPromoters}
            />
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <SelectCustom
              label="Tipo de usuário*"
              keyObject="Nome"
              value={typeUser}
              setValue={setTypeUser}
              error={errors.typeUser}
              optionsList={optionsTypeUsers}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <SelectCustom
              label="Perfil*"
              keyObject="Descricao"
              value={profile}
              setValue={setProfile}
              error={errors.profile}
              optionsList={optionsProfiles}
            />
          </Grid>

          <FormControlLabel
            style={{ color: "#828282" }}
            control={
              <Checkbox
                checked={active}
                onChange={() => setActive(!active)}
                name="checkedB"
                className="checkboxColor"
              />
            }
            label="Usuário Ativo"
          />

          <button
            id="buttonStyle"
            type="submit"
            className="btn btn-info btn-block"
          >
            Editar
          </button>
        </Grid>
      </Grid>
    </form>
  );
};

export default UpdateUser;
